<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：会员-用户列表-会员等级
  -->
  <el-dialog title="编辑地址" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="newform">
      <div class="common-form">当前地址信息</div>
      <el-col>
        <el-col :span="12">
          <el-form-item label="城市：" :label-width="formLabelWidth">
            <span>
              {{addresslist.city}}
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址：" :label-width="formLabelWidth">
            <div>
              <span>
                {{addresslist.new_address}}
              </span>
            </div>
          </el-form-item>
        </el-col>
      </el-col>

      <el-form-item label="">
        <el-row class="mb16">
          <el-col :span="24">
            <Getpoint :form="newform" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="城市" prop="city" :label-width="formLabelWidth">
        <el-input disabled v-model="newform.city" placeholder="请选择" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="详细地址" prop="new_address" :label-width="formLabelWidth">
        <el-input disabled v-model="newform.new_address" placeholder="请输入详细地址" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="经度：" :label-width="formLabelWidth">
        <el-input class="max-w460" v-model="newform.new_lng" disabled></el-input>
      </el-form-item>
      <el-form-item label="纬度：" :label-width="formLabelWidth">
        <el-input class="max-w460" v-model="newform.new_lat" disabled></el-input>
      </el-form-item>
      <!-- <el-form-item label="是否自动更新">
        <el-radio-group v-model="newform.level_status">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <div style="color:#ff6f06">注：根据获取位置自动更新</div>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible(false)">取 消</el-button>
      <el-button type="primary" @click="addressedit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Technician from "@/api/technician.js";
import Getpoint from "@/components/map/Getpoint.vue";
export default {
  components: {
    /*腾讯地图拾取器*/
    Getpoint
  },
  data() {
    return {
      aaa: "",
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      loading: false,
      dialogVisible: false,
      waiter_user_id: "",
      addresslist: {},
      newform: {
        waiter_user_id: "",
        new_lng: "",
        new_lat: "",
        new_address: "",
        city: ""
      }
    };
  },
  props: ["open_order", "form"],
  created() {
    this.dialogVisible = this.open_order;
    this.waiter_user_id = this.form.waiter_user_id;
    this.newform.waiter_user_id = this.form.waiter_user_id;
    this.getaddress();
  },
  methods: {
    /*获取经纬度*/
    getMapdataFunc(e) {
      console.log("获取经纬度", e);
      this.newform.new_lng = e.data[0].toFixed(6);
      this.newform.new_lat = e.data[1].toFixed(6);
      // this.newform.coordinate =
      //   e.data[0].toFixed(6) + "," + e.data[1].toFixed(6);
    },

    /*选择的地址*/
    choseFunc(e) {
      this.newform.new_lng = e.location.lng;
      this.newform.new_lat = e.location.lat;
      this.newform.city = e.address_component.city;
      this.newform.new_address = e.address;
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    /*获取*/
    getaddress() {
      let self = this;
      self.loading = true;
      // let params = self.form;
      Technician.getPositionData({ waiter_user_id: this.waiter_user_id }, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.addresslist = data.data;
            self.newform.new_lng = data.data.new_lng;
            self.newform.city = data.data.city;
            self.newform.new_lat = data.data.new_lat;
            self.newform.new_address = data.data.new_address;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*修改*/
    addressedit() {
      let self = this;
      self.loading = true;
      let params = self.newform;
      Technician.savePositionData(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            // self.addresslist = data.data;
            self.$message({
              message: "恭喜你，修改成功",
              type: "success"
            });
            self.dialogFormVisible(true);
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/dialog/waitewaddress.vue